/**
 * The service order object to be created.
 */
import {SupportedOperations} from '../get-service-order';
import {OrderRelatedContact} from './order-related-contact';
import {ServiceOrderComment} from './service-order-comment';
import {ServiceOrderJob} from './service-order-job';
import {ServiceOrderMileage} from './service-order-mileage';
import {ServiceOrderState} from './service-order-state';
import {VehicleReceptionData} from './vehicle-reception-data';

export class ServiceOrder {
  /** Text field on the Service order level. */
  comment?: ServiceOrderComment;

  /** The guide number assigned to the vehicle. Used to identify the vehicle during the repair process. */
  guideNumber?: string;

  /** BMW internal key to identify an order (GUID). */
  bmwServiceCaseId?: string;

  /** Order number as assigned by the DMS. */
  dmsServiceOrderId?: string;

  /** DMS specific status value of the order. */
  dmsServiceOrderState?: string;

  /** List of structured Jobs. All jobs must have change status "New". */
  jobList?: ServiceOrderJob[];

  /** The mileage of the vehicle at the time the service order was created or processed. */
  mileage?: ServiceOrderMileage;

  /** Dedicated contact information for questions or news regarding this service order. */
  orderRelatedContact?: OrderRelatedContact;

  /** The parking position of the vehicle. */
  parkingPosition?: string;

  /** Payment method the customer pays with, e.g. cash direct, credit card, invoice. */
  paymentMethod?: string;

  /** ID of a related appointment in an appointment scheduling system. */
  schedulingSystemAppointmentId?: string;

  /** Date, time and service advisor for the planned reception. */
  vehicleReceptionData?: VehicleReceptionData;

  /** Date, time and service advisor for the planned return date of the vehicle. */
  vehicleReturnData?: VehicleReceptionData;

  /** Timestamp when the order was created in DMS. */
  creationDateTime?: string;

  /** Indicates whether the customer will wait for repairs. */
  customerWillWait?: boolean;

  /** Supported operations based on current DMS state. */
  supportedOperations?: SupportedOperations;

  /** Status of the service order. */
  serviceOrderState?: ServiceOrderState;
}
